<template>
  <div>
    <Breadcrumb :breadcrumb="breadcrumb"></Breadcrumb>
    <div class="tabs">
      <ul>
        <li>
          <router-link
            :to="{ name: 'reportDialy', params: { projectId: projectId } }"
          >
            Daily
          </router-link>
        </li>
        <li class="is-active"><a>Weekly</a></li>
        <li>
          <router-link
            :to="{ name: 'reportMonthly', params: { projectId: projectId } }"
          >
            Monthly
          </router-link>
        </li>
      </ul>
    </div>
    <h5 class="title is-5">{{ $t("reports.weekly") }}</h5>
    <WeeklyGraph :tenant-id="tenantId" :project-id="projectId"></WeeklyGraph>
    <hr />
    <WeeklyReports
      :tenant-id="tenantId"
      :project-id="projectId"
    ></WeeklyReports>
  </div>
</template>
<script>
import { ref, computed } from "@vue/reactivity";
import { useRoute } from "vue-router";
import { useStore } from "vuex";
import Breadcrumb from "@/components/Breadcrumb";
import WeeklyGraph from "@/components/reports/weeklyGraph.vue";
import WeeklyReports from "@/components/reports/weeklyReports.vue";

export default {
  components: {
    Breadcrumb,
    WeeklyGraph,
    WeeklyReports,
  },
  setup() {
    const route = useRoute();
    const store = useStore();
    const breadcrumb = ref([
      {
        title: "Home",
        path: {
          name: "dashboard",
          params: { projectId: route.params.projectId },
        },
      },
      { title: "Report", path: "#", isActive: true },
    ]);

    return {
      breadcrumb,
      tenantId: computed(() => store.getters.tenantId),
      projectId: computed(() => route.params.projectId),
    };
  },
};
</script>
